export default {
  data() {
    return {
      calendar: {
        weeklyDays: [
          { name: "Monday" },
          { name: "Tuesday" },
          { name: "Wednesday" },
          { name: "Thursday" },
          { name: "Friday" },
          { name: "Saturday" },
          { name: "Sunday" },
        ],

        weekDayOrdinals: ["First", "Second", "Third", "Fourth", "Last"],

        weeklyIntervals: [
          { id: 1, name: "Every week" },
          { id: 2, name: "Every 2 weeks" },
          { id: 3, name: "Every 3 weeks" },
          { id: 4, name: "Every 4 weeks" },
          { id: 5, name: "Every 5 weeks" },
          { id: 6, name: "Every 6 weeks" },
          { id: 7, name: "Every 7 weeks" },
          { id: 8, name: "Every 8 weeks" },
          { id: 9, name: "Every 9 weeks" },
          { id: 10, name: "Every 10 weeks" },
          { id: 11, name: "Every 11 weeks" },
          { id: 12, name: "Every 12 weeks" },
        ],

        monthlyIntervals: [
          { id: 1, name: "Every month" },
          { id: 2, name: "Every 2 months" },
          { id: 3, name: "Every 3 months" },
          { id: 4, name: "Every 4 months" },
          { id: 5, name: "Every 5 months" },
          { id: 6, name: "Every 6 months" },
          { id: 7, name: "Every 7 months" },
          { id: 8, name: "Every 8 months" },
          { id: 9, name: "Every 9 months" },
          { id: 10, name: "Every 10 months" },
          { id: 11, name: "Every 11 months" },
          { id: 12, name: "Every 12 months" },
        ],

        days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],

        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],

        morningHours: [
          "0_am",
          "1_am",
          "2_am",
          "3_am",
          "4_am",
          "5_am",
          "6_am",
          "7_am",
          "8_am",
          "9_am",
          "10_am",
          "11_am",
          "12_pm",
        ],

        dayHours: [
          "6_am",
          "7_am",
          "8_am",
          "9_am",
          "10_am",
          "11_am",
          "12_pm",
          "1_pm",
          "2_pm",
          "3_pm",
          "4_pm",
          "5_pm",
          "6_pm",
        ],

        afternoonHours: [
          "12_pm",
          "1_pm",
          "2_pm",
          "3_pm",
          "4_pm",
          "5_pm",
          "6_pm",
          "7_pm",
          "8_pm",
          "9_pm",
          "10_pm",
          "11_pm",
          "0_am",
        ],

        hourMap: {
          "0_am": 0,
          "1_am": 1,
          "2_am": 2,
          "3_am": 3,
          "4_am": 4,
          "5_am": 5,
          "6_am": 6,
          "7_am": 7,
          "8_am": 8,
          "9_am": 9,
          "10_am": 10,
          "11_am": 11,
          "12_pm": 12,
          "1_pm": 13,
          "2_pm": 14,
          "3_pm": 15,
          "4_pm": 16,
          "5_pm": 17,
          "6_pm": 18,
          "7_pm": 19,
          "8_pm": 20,
          "9_pm": 21,
          "10_pm": 22,
          "11_pm": 23,
        },
      },
    };
  },
};
